import React, { useState, useRef ,useEffect} from "react";
import { Container, Row, Col, Form, Button, Table, Modal } from "react-bootstrap";
import { FaTrash, FaPlus, FaSave } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./AddPurchase.css";
import api from "../services/api";

const AddDayBook = () => {
  const [formData, setFormData] = useState({
    date: new Date().toISOString().split('T')[0],
    transactionType: "sale",
    documentNo: "",
    party: "",
    description: "",
    amount: "",
    paymentMode: "cash",
    referenceNo: "",
    notes: ""
  });

  const [dayBookEntries, setDayBookEntries] = useState([]);
  const [errors, setErrors] = useState({});
  const [showPartyModal, setShowPartyModal] = useState(false);
  const [currentBalance, setCurrentBalance] = useState(0);

  const navigate = useNavigate();

  // Sample data for customers and suppliers
  const [customers, setCustomers] = useState([]);
    const [workerList, setWorker] = useState([]);


  const [suppliers, setSuppliers] = useState([]);

  const [newParty, setNewParty] = useState({
    name: "",
    type: "customer",
    phone: "",
    address: "",
    gstNo: "",
    openingBalance: 0
  });

  useEffect(() => {
      fetchCustomers();
    }, []);
  
    const fetchCustomers = async () => {
      try {
        // setLoading(true);
        // setError(null);
        
        // Note: The customer_list.php expects JSON input, so we need to send an empty object
        const response = await api.post("/customer_list.php", {});
        
        if (response.data.head.code === 200) {
          
          setCustomers(response.data.body);
        } else {
          // setError(response.data.head.msg || "Failed to fetch customers");
        }
      } catch (err) {
        console.error("Error fetching customers:", err);
        // setError("Failed to load customers. Please try again.");
      } finally {
        // setLoading(false);
      }

      try {
        // setLoading(true);
        // setError(null);
        
        // Note: The customer_list.php expects JSON input, so we need to send an empty object
        const response = await api.post("/job_worker_list.php", {});
        
        if (response.data.head.code === 200) {
          
          setWorker(response.data.body);
        } else {
          // setError(response.data.head.msg || "Failed to fetch customers");
        }
      } catch (err) {
        console.error("Error fetching worker:", err);
        // setError("Failed to load customers. Please try again.");
      } finally {
        // setLoading(false);
      }

      try {
        // setLoading(true);
        // setError(null);
        
        // Note: The customer_list.php expects JSON input, so we need to send an empty object
        const response = await api.post("/supplier_list.php", {});
        
        if (response.data.head.code === 200) {
          
          setSuppliers(response.data.body);
        } else {
          // setError(response.data.head.msg || "Failed to fetch customers");
        }
      } catch (err) {
        console.error("Error fetching customers:", err);
        // setError("Failed to load customers. Please try again.");
      } finally {
        // setLoading(false);
      }
    };

  // Refs for ALL input fields
  const dateRef = useRef(null);
  const transactionTypeRef = useRef(null);
  const documentNoRef = useRef(null);
  const partyRef = useRef(null);
  const descriptionRef = useRef(null);
  const amountRef = useRef(null);
  const paymentModeRef = useRef(null);
  const referenceNoRef = useRef(null);
  const notesRef = useRef(null);

  const transactionTypes = [
    { value: "sale", label: "Sale" },
    { value: "purchase", label: "Purchase" },
    { value: "worker", label: "Job Work" },
    { value: "expense", label: "Expense" },
  ];

  const paymentModes = [
    { value: "cash", label: "Cash" },
    { value: "bank", label: "Bank Transfer" },
    { value: "cheque", label: "Cheque" },
    { value: "upi", label: "UPI" },
    { value: "card", label: "Card" }
  ];

  // Get appropriate party list based on transaction type
  const getPartyList = () => {
    switch (formData.transactionType) {
      case 'sale':
      // case 'receipt':
        return customers;
      case 'worker':
        return workerList;
      case 'purchase':
      // case 'payment':
        return suppliers;
      default:
        return []; // For other types, no predefined list
    }
  };
  console.log("================customers",customers);

  // Check if party should be dropdown or free text
  const shouldShowPartyDropdown = () => {
    return ['sale', 'purchase', 'worker'].includes(formData.transactionType);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }));
    }
    /*
        // Auto-generate document number based on type
        if (name === 'transactionType' && !formData.documentNo) {
          const prefix = getDocumentPrefix(value);
          const randomNum = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
          setFormData(prev => ({ 
            ...prev, 
            documentNo: `${prefix}-${randomNum}` 
          }));
        }
    */
    // Reset party when transaction type changes
    if (name === 'transactionType') {
      setFormData(prev => ({ ...prev, party: "" }));
    }
  };

  const getDocumentPrefix = (type) => {
    const prefixes = {
      sale: "INV",
      purchase: "PUR",
      worker: "RCP",
      payment: "PMT",
      delivery: "DN",
      expense: "EXP",
      journal: "JRN"
    };
    return prefixes[type] || "DOC";
  };

  const calculateAmounts = () => {
    let debit = 0;
    let credit = 0;

    switch (formData.transactionType) {
      case 'sale':
      // case 'receipt':
        credit = parseFloat(formData.amount) || 0;
        break;
      case 'purchase':
      case 'worker':
      case 'expense':
        debit = parseFloat(formData.amount) || 0;
        break;
      // case 'delivery':
      // case 'journal':
      //   debit = parseFloat(formData.amount) || 0;
        // break;
      default:
        break;
    }

    return { debit, credit };
  };

  // UPDATED: Improved keyboard navigation
  const handleKeyPress = (e, nextFieldRef) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (nextFieldRef && nextFieldRef.current) {
        nextFieldRef.current.focus();
      }
    }
  };

  // NEW: Special handler for amount field
  const handleAmountKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      // Don't add entry automatically, just navigate to payment mode
      if (paymentModeRef.current) {
        paymentModeRef.current.focus();
      }
    }
  };

  // NEW: Handler for notes field to add entry on Enter
  const handleNotesKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddEntry();
    }
  };

  const handleAddEntry = () => {
    const validationErrors = validateEntry();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const { debit, credit } = calculateAmounts();
    const amount = parseFloat(formData.amount) || 0;

    const newEntry = {
      id: Date.now(),
      date: formData.date,
      type: formData.transactionType,
      documentNo: formData.documentNo || "N/A",
      party: formData.party || "N/A",
      description: formData.description || "No description",
      debit: debit,
      credit: credit,
      amount: amount,
      paymentMode: formData.paymentMode,
      referenceNo: formData.referenceNo,
      notes: formData.notes
    };

    setDayBookEntries(prev => [...prev, newEntry]);
    setCurrentBalance(prev => prev + credit - debit);

    // Reset form but keep date and transaction type
    setFormData(prev => ({
      ...prev,
      documentNo: "",
      party: "",
      description: "",
      amount: "",
      paymentMode: "cash",
      referenceNo: "",
      notes: ""
    }));

    // Focus on document number for next entry
    documentNoRef.current.focus();
    setErrors({});
  };

  const validateEntry = () => {
    const newErrors = {};
    if (!formData.amount || parseFloat(formData.amount) <= 0) {
      newErrors.amount = "Valid amount is required";
    }
    return newErrors;
  };

  const handleDeleteEntry = (index) => {
    const entryToDelete = dayBookEntries[index];
    setCurrentBalance(prev => prev - entryToDelete.credit + entryToDelete.debit);
    const updatedEntries = dayBookEntries.filter((_, i) => i !== index);
    setDayBookEntries(updatedEntries);
  };

  // Party Modal Functions
  const handleShowPartyModal = () => {
    // Set the party type based on transaction type
    const partyType = ['sale'].includes(formData.transactionType) ? 'customer' : 'supplier';
    setNewParty(prev => ({ ...prev, type: partyType }));
    setShowPartyModal(true);
  };

  const handleClosePartyModal = () => {
    setShowPartyModal(false);
    setNewParty({
      name: "",
      type: "customer",
      phone: "",
      address: "",
      gstNo: "",
      openingBalance: 0
    });
  };

  const handleNewPartyChange = (e) => {
    const { name, value } = e.target;
    setNewParty(prev => ({ ...prev, [name]: value }));
  };

  const handleAddParty = () => {
    if (newParty.name.trim()) {
      if (newParty.type === 'customer') {
        setCustomers(prev => [...prev, newParty.name]);
      } else if(newParty.type === 'worker') {
        setWorker(prev => [...prev, newParty.name]);
      } else {
        setSuppliers(prev => [...prev, newParty.name]);
      }
      setFormData(prev => ({ ...prev, party: newParty.name }));
      handleClosePartyModal();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    /*
    if (dayBookEntries.length === 0) {
      alert("Please add at least one day book entry");
      return;
    }
    */
    const formatDateToDMY = (date) => {
      if (!date) return "";
      const [yyyy, mm, dd] = date.split("-");
      return `${dd}-${mm}-${yyyy}`;
    };
    const payload = {
      entry_date: formatDateToDMY(formData.date),
      transaction_type: formData.transactionType,
      document_no: formData.documentNo,
      party_name: formData.party,
      description: formData.description,
      amount: formData.amount,
      payment_mode: formData.paymentMode,
      reference_no: formData.referenceNo,
      notes: formData.notes,
      // entries: dayBookEntries,
      // openingBalance: 0,
      // closingBalance: currentBalance,
      // totalDebit: dayBookEntries.reduce((sum, entry) => sum + entry.debit, 0),
      // totalCredit: dayBookEntries.reduce((sum, entry) => sum + entry.credit, 0),
      status: "draft"
    };

    console.log("Day Book entries saved:", payload);
    const response = await api.post("/daybook_add.php", payload);

    if (response.data.head.code === 200) {
      alert("Day Book entries saved successfully!");
      navigate("/daybook");
    }

    // Reset for new entries
    setDayBookEntries([]);
    setCurrentBalance(0);
    setFormData({
      date: new Date().toISOString().split('T')[0],
      transactionType: "sale",
      documentNo: "",
      party: "",
      description: "",
      amount: "",
      paymentMode: "cash",
      referenceNo: "",
      notes: ""
    });
  };

  const getTotalDebit = () => dayBookEntries.reduce((sum, entry) => sum + entry.debit, 0);
  const getTotalCredit = () => dayBookEntries.reduce((sum, entry) => sum + entry.credit, 0);

  const renderError = (field) =>
    errors[field] ? <div className="text-danger small mt-1">{errors[field]}</div> : null;

  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Add Day Book Entries</h4>
        <Button className="btn-top" onClick={() => navigate("/daybook")}>Back to Day Book</Button>
      </div>

      <Form onSubmit={(e) => e.preventDefault()} noValidate>
        <Row className="g-3">
          {/* Date Field */}
          <Col lg={4} md={4} sm={12}>
            <Form.Group>
              <Form.Label>Date</Form.Label>
              <Form.Control
                ref={dateRef}
                name="date"
                type="date"
                value={formData.date}
                onChange={handleChange}
                onKeyPress={(e) => handleKeyPress(e, transactionTypeRef)}
              />
            </Form.Group>
          </Col>

          {/* Transaction Type */}
          <Col lg={4} md={4} sm={12}>
            <Form.Group>
              <Form.Label>Transaction Type</Form.Label>
              <Form.Select
                ref={transactionTypeRef}
                name="transactionType"
                value={formData.transactionType}
                onChange={handleChange}
                onKeyPress={(e) => handleKeyPress(e, documentNoRef)}
              >
                {transactionTypes.map(type => (
                  <option key={type.value} value={type.value}>{type.label}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          {/* Document No */}
          <Col lg={4} md={4} sm={12}>
            <Form.Group>
              <Form.Label>Document No / Bill No</Form.Label>
              <Form.Control
                ref={documentNoRef}
                name="documentNo"
                type="text"
                value={formData.documentNo}
                onChange={handleChange}
                placeholder="Enter document number (optional)"
                onKeyPress={(e) => handleKeyPress(e, partyRef)}
              />
            </Form.Group>
          </Col>


          {/* Party Selection - UPDATED */}
          <Col lg={4} md={4} sm={12}>
            <Form.Group>
              <Form.Label>Party</Form.Label>
              <div className="d-flex gap-2">
                {shouldShowPartyDropdown() ? (
                  <Form.Select
                    ref={partyRef}
                    name="party"
                    value={formData.party}
                    onChange={handleChange}
                    onKeyPress={(e) => handleKeyPress(e, descriptionRef)}
                  >
                    <option value="">Select Party</option>
                    {getPartyList().map((party, index) => (
                      <option key={index} value={party.name}>{party.name}</option>
                    ))}
                  </Form.Select>
                ) : (
                  <Form.Control
                    ref={partyRef}
                    name="party"
                    type="text"
                    value={formData.party}
                    onChange={handleChange}
                    placeholder="Enter party name (optional)"
                    onKeyPress={(e) => handleKeyPress(e, descriptionRef)}
                  />
                )}
                {shouldShowPartyDropdown() && (
                  <Button
                    variant="outline-primary"
                    onClick={handleShowPartyModal}
                    className="d-flex align-items-center"
                    title="Add New Party"
                  >
                    <FaPlus />
                  </Button>
                )}
              </div>
            </Form.Group>
          </Col>

          {/* Description */}
          <Col lg={8} md={8} sm={12}>
            <Form.Group>
              <Form.Label>Description</Form.Label>
              <Form.Control
                ref={descriptionRef}
                name="description"
                type="text"
                value={formData.description}
                onChange={handleChange}
                placeholder="Enter description (optional)"
                onKeyPress={(e) => handleKeyPress(e, amountRef)}
              />
            </Form.Group>
          </Col>

          {/* Amount */}
          <Col lg={3} md={3} sm={12}>
            <Form.Group>
              <Form.Label>Amount (₹) *</Form.Label>
              <Form.Control
                ref={amountRef}
                name="amount"
                type="number"
                value={formData.amount}
                onChange={handleChange}
                placeholder="0.00"
                min="0"
                step="0.01"
                onKeyPress={handleAmountKeyPress} // Updated handler
              />
              {renderError("amount")}
            </Form.Group>
          </Col>

          {/* Payment Mode - UPDATED with ref */}
          <Col lg={3} md={3} sm={12}>
            <Form.Group>
              <Form.Label>Payment Mode</Form.Label>
              <Form.Select
                ref={paymentModeRef}
                name="paymentMode"
                value={formData.paymentMode}
                onChange={handleChange}
                onKeyPress={(e) => handleKeyPress(e, referenceNoRef)}
              >
                {paymentModes.map(mode => (
                  <option key={mode.value} value={mode.value}>{mode.label}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          {/* Reference No - UPDATED with ref */}
          <Col lg={6} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Reference No</Form.Label>
              <Form.Control
                ref={referenceNoRef}
                name="referenceNo"
                type="text"
                value={formData.referenceNo}
                onChange={handleChange}
                placeholder="Optional reference number"
                onKeyPress={(e) => handleKeyPress(e, notesRef)}
              />
            </Form.Group>
          </Col>

          {/* Notes - UPDATED with ref and Enter handler 
          <Col lg={4} md={4} sm={12}>
            <Form.Group>
              <Form.Label>Notes</Form.Label>
              <Form.Control
                ref={notesRef}
                name="notes"
                as="textarea"
                rows={1}
                value={formData.notes}
                onChange={handleChange}
                placeholder="Additional notes (optional)"
                onKeyPress={handleNotesKeyPress} // Add entry on Enter
              />
              <div className="text-center mt-1">
                <small className="text-muted">Press Enter to add entry</small>
              </div>
            </Form.Group>
          </Col>*/}
        </Row>

        {/* Entries Table 
        <Row className="mt-4">
          <Col xs={12}>
            <div className="table-responsive">
              <Table bordered className="purchase-table">
                <thead className="table-dark">
                  <tr>
                    <th width="5%">Sno</th>
                    <th width="10%">Type</th>
                    <th width="15%">Document No</th>
                    <th width="15%">Party</th>
                    <th width="20%">Description</th>
                    <th width="10%" className="text-end">Debit (₹)</th>
                    <th width="10%" className="text-end">Credit (₹)</th>
                    <th width="10%">Payment Mode</th>
                    <th width="5%">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {dayBookEntries.map((entry, index) => (
                    <tr key={entry.id}>
                      <td className="text-center">{index + 1}</td>
                      <td>
                        <span className="text-uppercase small fw-bold">{entry.type}</span>
                      </td>
                      <td>
                        <strong>{entry.documentNo}</strong>
                        {entry.referenceNo && <div><small className="text-muted">Ref: {entry.referenceNo}</small></div>}
                      </td>
                      <td>{entry.party}</td>
                      <td>
                        <div>{entry.description}</div>
                        {entry.notes && <small className="text-muted">{entry.notes}</small>}
                      </td>
                      <td className="text-end">
                        {entry.debit > 0 && (
                          <span className="text-danger fw-bold">
                            ₹{entry.debit.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                          </span>
                        )}
                      </td>
                      <td className="text-end">
                        {entry.credit > 0 && (
                          <span className="text-success fw-bold">
                            ₹{entry.credit.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                          </span>
                        )}
                      </td>
                      <td className="text-capitalize">{entry.paymentMode}</td>
                      <td className="text-center">
                        <FaTrash
                          className="delete-icon"
                          style={{ cursor: 'pointer', color: '#dc3545' }}
                          onClick={() => handleDeleteEntry(index)}
                          title="Delete Entry"
                        />
                      </td>
                    </tr>
                  ))}
                  {dayBookEntries.length === 0 && (
                    <tr>
                      <td colSpan="9" className="text-center text-muted py-3">
                        No entries added yet. Fill the form and press Enter in notes field to add entries.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
        */}

        {/* Totals Section 
        <Row className="mt-4">
          <Col xs={12} className="d-flex justify-content-end">
            <div className="totals-section">
              <div className="total-row">
                <span className="total-label">Total Debit:</span>
                <span className="total-value">₹{getTotalDebit().toFixed(2)}</span>
              </div>
              <div className="total-row">
                <span className="total-label">Total Credit:</span>
                <span className="total-value">₹{getTotalCredit().toFixed(2)}</span>
              </div>
              <div className="total-row grand-total">
                <span className="total-label">Net Balance:</span>
                <span className={`total-value ${currentBalance >= 0 ? 'text-success' : 'text-danger'}`}>
                  ₹{Math.abs(currentBalance).toFixed(2)}
                  {currentBalance >= 0 ? ' Dr' : ' Cr'}
                </span>
              </div>
            </div>
          </Col>
        </Row>
        */}

        {/* Submit Buttons */}
        <div className="d-flex justify-content-end mt-4 gap-2">
          <Button
            type="button"
            className="btn-submit"
            onClick={handleSubmit}
          // disabled={dayBookEntries.length === 0}
          >
            <FaSave className="me-2" /> Save Day Book
          </Button>
          <Button type="button" className="btn-top" onClick={() => navigate("/daybook")}>Cancel</Button>
        </div>
      </Form>

      {/* Add Party Modal */}
      <Modal show={showPartyModal} onHide={handleClosePartyModal}>
        <Modal.Header closeButton>
          <Modal.Title>Add New {newParty.type === 'customer' ? 'Customer' : 'Supplier'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Party Name *</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={newParty.name}
                onChange={handleNewPartyChange}
                placeholder="Enter party name"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Phone No</Form.Label>
              <Form.Control
                type="text"
                name="phone"
                value={newParty.phone}
                onChange={handleNewPartyChange}
                placeholder="Enter phone number"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Address</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="address"
                value={newParty.address}
                onChange={handleNewPartyChange}
                placeholder="Enter address"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>GST Number</Form.Label>
              <Form.Control
                type="text"
                name="gstNo"
                value={newParty.gstNo}
                onChange={handleNewPartyChange}
                placeholder="Enter GST number"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClosePartyModal}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAddParty} disabled={!newParty.name.trim()}>
            Add {newParty.type === 'customer' ? 'Customer' : 'Supplier'}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default AddDayBook;